export const AdminSectionContentTypeEnum = {
    Produto: 1 ,
    Servico: 2 ,
    Curso: 3
}



// WEBPACK FOOTER //
// ./src/enums/AdminSectionContentTypeEnum.js